import { useAuth } from "../context/AuthContext";
import { useOrganization } from "../context/OrganizationContext";
import "./ProfilePage.css";

export function ProfilePage() {
  const { user, changePassword } = useAuth();
  const { activeOrganization } = useOrganization();

  if (!user) {
    return (
      <div className="profile">
        <p style={{ color: "#64748b" }}>Sign in to view your profile.</p>
      </div>
    );
  }

  const initials = user.name
    ? user.name
        .split(" ")
        .map((n) => n.charAt(0))
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "U";

  return (
    <div className="profile">
      <h2 className="profile-title">Profile</h2>

      {/* ── Profile info card ──────────────────────── */}
      <div className="profile-card">
        <div className="profile-info-header">
          <span className="profile-avatar">{initials}</span>
          <div>
            <div className="profile-avatar-name">{user.name || "Haven User"}</div>
            <div className="profile-avatar-email">{user.email}</div>
          </div>
        </div>

        <div className="profile-info-row">
          <span className="profile-info-label">Name</span>
          <span className="profile-info-value">{user.name || "\u2014"}</span>
        </div>
        <div className="profile-info-row">
          <span className="profile-info-label">Email</span>
          <span className="profile-info-value">{user.email || "\u2014"}</span>
        </div>
        {activeOrganization?.name && (
          <div className="profile-info-row">
            <span className="profile-info-label">Organization</span>
            <span className="profile-info-value">{activeOrganization.name}</span>
          </div>
        )}
        {user.roles.length > 0 && (
          <div className="profile-info-row">
            <span className="profile-info-label">Roles</span>
            <span className="profile-info-value">{user.roles.join(", ")}</span>
          </div>
        )}
      </div>

      {/* ── Security card ──────────────────────────── */}
      <div className="profile-card">
        <h3 className="profile-card-title">Security</h3>
        <p className="profile-security-desc">
          Manage your password and account security settings.
        </p>
        <button
          type="button"
          className="profile-submit-btn"
          onClick={changePassword}
        >
          Change password
        </button>
      </div>
    </div>
  );
}
